var map = {
	"./logo-alphabet.svg": 793,
	"./logo-amazon-2.svg": 794,
	"./logo-amazon.svg": 1002,
	"./logo-azercell.svg": 1003,
	"./logo-bank-of-america.svg": 1004,
	"./logo-barclays.svg": 1005,
	"./logo-bbc.svg": 1006,
	"./logo-bloomberg.svg": 795,
	"./logo-bnp-paribas.svg": 1007,
	"./logo-booking.svg": 1008,
	"./logo-citibank.svg": 1009,
	"./logo-cnbc.svg": 796,
	"./logo-cnbc2.svg": 1010,
	"./logo-coca-cola-auto.svg": 792,
	"./logo-coca-cola-white.svg": 1795,
	"./logo-coca-cola.svg": 1011,
	"./logo-deloitte.svg": 1012,
	"./logo-experian.svg": 1013,
	"./logo-facebook.svg": 1014,
	"./logo-forbes.svg": 797,
	"./logo-g.svg": 1796,
	"./logo-goldman-sachs-new.svg": 1015,
	"./logo-goldman-sachs.svg": 1499,
	"./logo-google-new.svg": 1016,
	"./logo-google.svg": 1017,
	"./logo-h.svg": 1018,
	"./logo-henkel.svg": 1019,
	"./logo-hsbc-new.svg": 1020,
	"./logo-hsbc.svg": 1497,
	"./logo-ikea-new.svg": 1021,
	"./logo-ikea.svg": 1797,
	"./logo-infineon.svg": 1022,
	"./logo-instagram-icon.svg": 790,
	"./logo-instagram.svg": 1023,
	"./logo-jp-morgan.svg": 1024,
	"./logo-jti.svg": 1025,
	"./logo-linkedin.svg": 1026,
	"./logo-meta-new.svg": 789,
	"./logo-meta.svg": 1500,
	"./logo-morgan-stanley-new.svg": 1027,
	"./logo-morgan-stanley.svg": 1498,
	"./logo-netflix.svg": 1495,
	"./logo-oracle.svg": 798,
	"./logo-paypal.svg": 1028,
	"./logo-pwc-new.svg": 791,
	"./logo-pwc.svg": 1798,
	"./logo-spotify.svg": 1496,
	"./logo-tesla.svg": 1029,
	"./logo-usa-today.svg": 799,
	"./logo-visa.svg": 1030,
	"./logo-walmart.svg": 800,
	"./logo-wsj.svg": 801,
	"./logo-youtube.svg": 1031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1334;